import Layout from "../../components/layOutWrapper/layOutWrapper";
import { ShowAllTravelAllowanceRequests } from "../../components/travelAllowanceRequests/showAllTravelAllowanceRequests";

export default function AllTravelAllowanceRequestsView () {
    return (
        <>
            <Layout children={<ShowAllTravelAllowanceRequests {... {endpointURL: `/v1/travelAllowanceRequestController/allTravelAllowanceRequests`}}/>} sectionTitle="Todas las solicitudes de viáticos"/>
        </>
    )
}